import { compileString } from 'sass';
import { useStore } from '~/store';
import { isArray } from '~/libs/shared/utils/src/Common/Common';

export default defineNuxtRouteMiddleware(async (to) => {
  const segments = to.path.split('/');
  const locale = segments[1] || 'en';

  const nuxtApp = useNuxtApp();
  const store = useStore(nuxtApp.$pinia);

  store.setLoading(true);

  if (store.$state.pageConfig) {
    store.resetPageConfig();
  }

  const { data, error } = await useAsyncData(
      'pageConfig',
      () => $fetch(`/${locale}/${to.params.category}/${to.params.slug}/api/project`),
      {
        server: true,
        transform: (data) => {
          // validate and convert scss styles comes from admin panel for certain page
          if (false) {
            try {
              const css = compileString(data.styles || '').css;
              data.styles = css || '';
            } catch (e) {
              store.addWarn(e.toString());
              data.styles = '';
            }
          }
          return data;
        },
      }
  ).finally(() => {
    store.setLoading(false);
  });

  if (error.value) {
    console.error('Error fetching page config:', error.value);
    return abortNavigation();
  }

  if (!data.value || !data.value.id || !isArray(data.value.blocks)) {
    try {
      console.log('No data for this locale, try to redirect: ' + to?.path);
      if (locale === 'ar') {
        if (true) {
          window.location.href = to.path.replace('/ar/', '/en/');
        } else {
          return navigateTo(to.path.replace('/ar/', '/en/'), { external: true });
        }
      }
    } catch (e) {
      console.log(e);
    }

    return createError({ statusCode: 404, message: 'Page not found' });
  } else {
    store.setPageConfig(data.value);
  }
});